/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { loginAuthLoginPost } from '../fn/auth/login-auth-login-post';
import { LoginAuthLoginPost$Params } from '../fn/auth/login-auth-login-post';
import { BackendLoginResponseDto } from '../models/backend-login-response-dto';
import { meAuthMeGet } from '../fn/auth/me-auth-me-get';
import { MeAuthMeGet$Params } from '../fn/auth/me-auth-me-get';
import { BackendMeResponseDto } from '../models/backend-me-response-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiAuthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `loginAuthLoginPost()` */
  static readonly LoginAuthLoginPostPath = '/auth/login';

  /**
   * Логин через FreeIPA → JWT.
   *
   * Search+bind в FreeIPA, проверка членства в `LDAP_REQUIRE_GROUP_DN`, связка с `account_user` в master-БД, выпуск JWT (TTL = `JWT_TTL_SECONDS`).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loginAuthLoginPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  loginAuthLoginPost$Response(
    params: LoginAuthLoginPost$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLoginResponseDto>> {
    return loginAuthLoginPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Логин через FreeIPA → JWT.
   *
   * Search+bind в FreeIPA, проверка членства в `LDAP_REQUIRE_GROUP_DN`, связка с `account_user` в master-БД, выпуск JWT (TTL = `JWT_TTL_SECONDS`).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `loginAuthLoginPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  loginAuthLoginPost(params: LoginAuthLoginPost$Params, context?: HttpContext): Observable<BackendLoginResponseDto> {
    return this.loginAuthLoginPost$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLoginResponseDto>): BackendLoginResponseDto => r.body),
    );
  }

  /** Path part for operation `meAuthMeGet()` */
  static readonly MeAuthMeGetPath = '/auth/me';

  /**
   * Данные текущего пользователя из JWT.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meAuthMeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  meAuthMeGet$Response(
    params?: MeAuthMeGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMeResponseDto>> {
    return meAuthMeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Данные текущего пользователя из JWT.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meAuthMeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meAuthMeGet(params?: MeAuthMeGet$Params, context?: HttpContext): Observable<BackendMeResponseDto> {
    return this.meAuthMeGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMeResponseDto>): BackendMeResponseDto => r.body),
    );
  }
}
